import { useCallback } from "react";
import { toast } from "react-toastify";
import { getSessionActions } from "../status/getSessionActions";
import { WebinarSession } from "../types/models";

type Handlers = {
  openEdit: (session: WebinarSession) => void;
  copyJoinLink: (session: WebinarSession) => void | Promise<boolean>;
  reinstateSession: (session: WebinarSession) => void | Promise<boolean>;
  /** Chief-coach only for mutation primaries. */
  canManage?: boolean;
};

/**
 * Maps row primary CTA (Continue setup / Copy join link / …) to handlers.
 */
export function useSessionPrimaryAction({
  openEdit,
  copyJoinLink,
  reinstateSession,
  canManage = true,
}: Handlers) {
  return useCallback(
    async (session: WebinarSession) => {
      const actions = getSessionActions(session, { canManage });
      if (!actions.primary) return;
      switch (actions.primary) {
        case "continue_setup":
          if (!canManage) {
            toast.info("Only a chief coach can edit sessions");
            break;
          }
          openEdit(session);
          break;
        case "copy_join_link":
          await copyJoinLink(session);
          break;
        case "live_console":
          toast.info("Opening the live console…");
          break;
        case "view_report":
          toast.info(
            "Attendance, rewards and testimonial requests are in the report"
          );
          break;
        case "reinstate":
          if (!canManage || !actions.canReinstate) {
            toast.info(
              canManage
                ? "Reinstate is not available yet"
                : "Only a chief coach can reinstate sessions"
            );
            break;
          }
          await reinstateSession(session);
          break;
        default:
          break;
      }
    },
    [openEdit, copyJoinLink, reinstateSession, canManage]
  );
}
